/**
 * Affichage d'une erreur d'API.
 *
 * Chaque code appelle une reaction differente (CDC §9) : un lien expire
 * n'est pas un lien inconnu, et un plafond de demandes n'est pas une
 * panne. Les confondre derriere un "une erreur est survenue" laisserait le
 * signataire sans savoir quoi faire - or dans la moitie des cas il ne peut
 * rien corriger lui-meme et doit contacter l'emetteur.
 */
import type { ApiError } from "../api";
import type { t } from "../i18n";

interface Props {
  error: ApiError;
  L: ReturnType<typeof t>;
  onRetry?: () => void;
}

export function ErrorPanel({ error, L, onRetry }: Props) {
  const message = L.errors[error.kind] ?? L.errors.server;

  return (
    <div className="stack">
      {/* role="alert" : annonce immediatement par les lecteurs d'ecran,
          sans quoi un utilisateur non voyant reste sur l'ecran precedent
          sans savoir que son action a echoue. */}
      <div className="alert alert--error" role="alert">
        {message}
      </div>
      {onRetry && (
        <button type="button" className="btn btn--secondary" onClick={onRetry}>
          {L.retry}
        </button>
      )}
    </div>
  );
}
